<div mat-dialog-container>
  <div mat-dialog-content>
    <div class="close-row">
      <a (click)="close()">
        <img
          class="close-icon"
          src="assets/images/shared/Icon - Close - Active.svg"
        />
      </a>
    </div>
    <div class="modal-title" style="text-align: center">Terms of Use</div>
    <div class="terms-of-use-body">
      <div class="std-fs-s std-fs-md-xs std-fw-normal text-justify">
        <p>
          <b>GENERAL </b> <br />
          By accessing the “Allianz SAT” and using its contents, you acknowledge
          and agree that you have read and understood the following terms of use
          and you agree to be bound by them. Do not use or access the SAT if you
          do not agree with these terms of use. <br /><br />As used below, the
          terms “we”, “us”, and “our” refer to Allianz General Insurance Company
          (Malaysia) Berhad (“Allianz General”). <br />

          <br /><b> USE OF ALLIANZ SAT </b><br />
          Allianz SAT and its content is for information and to enable you to
          submit the relevant information collected from customers including
          premium payment details for purposes of underwriting and assessment of
          the customers’ risk for policy issuance. <br />

          <br /><b>NO DUTY TO UPDATE</b><br />
          All content on the Allianz SAT is published as of its date only. We
          assume no responsibility to update or amend.<br />

          <br /><b>COPYRIGHT</b> <br />
          All content of the Allianz SAT is protected by copyright with all
          rights reserved. All rights to the pages, site content and arrangement
          are owned by Allianz General. You are prohibited from copying,
          modifying, displaying, distributing, transmitting redelivering through
          the use of “framing” technology, publishing, selling, creating
          derivative works or using any content of the Allianz SAT for any
          purpose without the prior written approval of Allianz General. <br />

          <br /><b>TRADEMARKS, SERVICE MARKS AND LOGOS (“MARKS”)</b><br />
          The marks appearing on the Allianz SAT are property of the Allianz
          Group and are not to be used without the prior written consent of
          Allianz General and/or the relevant Allianz group company.<br />

          <br /><b>NO WARRANTY</b><br />
          All content on the Allianz SAT, including but not limited to graphics,
          text and hyperlinks or references to other sites, is provided on an
          “as is” basis without warranty of any kind, express or implied,
          including but not limited to implied warranties of merchantability,
          fitness for a particular purposes, non-infringement and freedom from
          computer viruses or other harmful components. <br /><br />

          We do not warrant the adequacy, reliability or completeness of any
          information on the Allianz SAT and expressly disclaim any liability
          for errors or omissions therein. <br /><br />

          We do not warrant that the functions of the Allianz SAT will be
          uninterrupted and/or error-free, or that defects will be corrected or
          that the Allianz SAT or the server that makes it available are free
          from computer viruses or other harmful components. <br />

          <br /><b>DISCLAIMER OF LIABILITY</b><br />
          We expressly disclaim any liability, whether in contract, tort, strict
          liability or otherwise, for any direct, indirect, incidental,
          consequential, punitive or special damages arising out of or in any
          way connected with your access or use or inability to access or use
          the Allianz SAT or your reliance on its content, or any failure of
          performance, interruption , defect, delay in transmission, computer
          viruses or other harmful components, of line or system failure
          associated with the Allianz SAT, regardless of our knowledge thereof.
          <br />

          <br /><b>DISCLAIMERS</b><br />
          There are no implied or express warranties on the materials in this
          site. Allianz does not warrant or represent that the materials in this
          site are correct, accurate, or reliable. You assume the entire cost of
          all necessary servicing, repairs, or correction of any device damaged
          due to your accessing the internet materials contained in the Allianz
          SAT. This disclaimer applies even if Allianz General has been advised
          of the possibility of such damages.<br />

          <br /><b>HYPERLINKED AND REFERENCED WEBSITES</b><br />
          Certain hyperlinks or referenced websites on the Allianz SAT may, for
          your convenience, forward you to third parties’ websites which
          generally are recognised by their top level domain name. Their content
          has not been investigated or analysed by us and we do not warrant the
          adequacy, accuracy, reliability or completeness of any information non
          hyperlinked or referenced websites and expressly disclaim any
          liability for any and all of their content. We further do not warrant
          that the hyperlinks or referenced websites are free from viruses and
          expressly disclaim any liability for any and all of their content and
          damages resulting from its use.<br /><br />

          Allianz General is not in any way responsible for the content of any
          site owned by a third party that may be linked to its internet sites
          by hyperlink, whether such hyperlink is provided by Allianz General or
          by a third party. Allianz General makes no representations whatsoever
          about any other internet site which you may access through this
          website. When you access a non-Allianz internet site, please
          understand that it is independent, and that Allianz General has no
          control over the content on that internet site. In addition, a link to
          a non-Allianz internet site does not imply that Allianz General
          endorses or otherwise accepts any responsibility for the content, or
          the use, of the linked internet site.<br /><br />

          By accessing the Allianz SAT, you also agree to abide by the
          proprietary guidelines set forth at any website accessed or
          hyperlinked through the Allianz SAT. <br />

          <br /><b>LOCAL LEGAL RESTRICTIONS</b><br />
          The Allianz SAT is not directed to any person in any jurisdiction
          where (by reason of that person’s nationality, residence or otherwise)
          the publication or availability or the Allianz SAT is prohibited.
          Persons in respect of whom such prohibitions apply must not access the
          Allianz SAT. <br />

          <br /><b>RESERVATIONS OF RIGHTS</b><br />
          We reserve the right to change, modify, add or remove portions of
          these terms of use at any time without any reference to you. <br />

          <br /><b>SEVERABILITY</b><br />
          In the event any provision of these terms is held to be unenforceable,
          such provision shall be ineffective but the validity or enforceability
          of the remaining provisions will not be affected.<br />

          <br /><b>JURISDICTION</b><br />
          Any action arising out of these terms or your use of the Allianz SAT
          shall be governed by the laws of Malaysia and you agree to submit to
          the exclusive jurisdiction of the courts of Malaysia. By logging in
          with your User ID and password, you acknowledge and agree to the terms
          above.
        </p>
      </div>
    </div>
  </div>
</div>
